import { type ReactElement } from 'react';
import { DataTableGrid } from './DataTableGrid';
import { DataTableServer } from './DataTableServer';
import type { DataTableProps } from './dataTableShared';
import type { GridValidRowModel } from '@/ui/primitives';

export const DataTable = <T extends GridValidRowModel>(props: DataTableProps<T>): ReactElement => {
  if ('server' in props && props.server) {
    return <DataTableServer {...props} />;
  }

  return <DataTableGrid {...props} />;
};
